(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fireplace-customizer"] && !Shopify.designMode) return;
  try {
    
  function FireplaceCustomizer(container) {
    this.container = container;
    this.sectionId = this.container.dataset.sectionId;
    
    this.steps = Array.from(this.container.querySelectorAll('.customizer-step'));
    this.summaryStep = this.container.querySelector('.customizer-summary-step');
    this.nextButton = this.container.querySelector('.next-button');
    this.prevButton = this.container.querySelector('.prev-button');
    this.addToCartButton = this.container.querySelector('#add-to-cart-button-' + this.sectionId);
    this.progressIndicator = this.container.querySelector('#progress-indicator-' + this.sectionId);
    this.summaryList = this.container.querySelector('#summary-list-' + this.sectionId);
    
    this.assetsContainer = document.getElementById('customizer-assets-' + this.sectionId);
    this.placeholderSvg = this.assetsContainer ? this.assetsContainer.querySelector('[data-asset="placeholder-svg"]').innerHTML : '';

    this.currencyCode = this.container.dataset.currencyCode || 'USD';
    this.mainAtcWarningText = this.container.dataset.mainAtcWarning || '';

    this.currentStepIndex = 0;
    this.selections = {};
    this.availableSteps = [];
    
    this.init = async function() {
      if (this.steps.length === 0) {
          if(this.summaryStep) this.summaryStep.style.display = 'block';
          if(this.nextButton) this.nextButton.style.display = 'none';
          if(this.prevButton) this.prevButton.style.display = 'none';
          return;
      }
      
      await this.loadProductsForSteps();
      this.calculateAvailableSteps();
      this.renderProgressIndicator();
      this.showStep(this.currentStepIndex);
      this.attachEventListeners();
      this.initMainATCListener();
    }.bind(this);

    this.fetchProductData = async function(handle) {
      try {
        const response = await fetch('/products/' + handle + '.js');
        if (!response.ok) throw new Error('Product not found: ' + handle);
        return await response.json();
      } catch (error) {
        console.error('[Customizer] Error fetching product data for handle "' + handle + '":', error);
        return null;
      }
    }.bind(this);

    this.createProductCard = function(product) {
      const card = document.createElement('div');
      card.className = 'product-option-card';
      card.tabIndex = 0;

      const firstAvailableVariant = product.variants.find(function(v) { return v.available; });
      const price = new Intl.NumberFormat(this.currencyCode, { style: 'currency', currency: this.currencyCode }).format(product.price / 100);
      const providesTags = product.tags.join(',');

      let priceHTML = '<span>' + price + '</span>';
      let compareAtPriceFormatted = '';
      if (product.compare_at_price && product.compare_at_price > product.price) {
        compareAtPriceFormatted = new Intl.NumberFormat(this.currencyCode, { style: 'currency', currency: this.currencyCode }).format(product.compare_at_price / 100);
        priceHTML = '<del>' + compareAtPriceFormatted + '</del> ' + priceHTML;
      }

      const featuredImageSrc = product.featured_image ? product.featured_image.replace(/(\.jpg|\.png|\.gif|\.jpeg)/, '_300x$&') : null;

      const imageWrapper = document.createElement('div');
      imageWrapper.className = 'product-option-image-wrapper';
      if (featuredImageSrc) {
          const img = document.createElement('img');
          img.src = featuredImageSrc;
          img.alt = product.title;
          img.loading = 'lazy';
          img.width = 300;
          img.height = 300;
          imageWrapper.appendChild(img);
      } else {
          const placeholder = document.createElement('div');
          placeholder.innerHTML = this.placeholderSvg;
          imageWrapper.appendChild(placeholder.firstElementChild);
      }
      
      const info = document.createElement('div');
      info.className = 'product-option-info';
      const title = document.createElement('h3');
      title.className = 'product-option-title';
      title.textContent = product.title;
      const priceEl = document.createElement('p');
      priceEl.className = 'product-option-price';
      priceEl.innerHTML = firstAvailableVariant ? priceHTML : 'Unavailable';
      info.appendChild(title);
      info.appendChild(priceEl);

      const check = document.createElement('div');
      check.className = 'product-selected-indicator';
      check.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24" height="24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"></path></svg>';

      card.appendChild(imageWrapper);
      card.appendChild(info);
      card.appendChild(check);

      if (firstAvailableVariant) {
        card.setAttribute('role', 'button');
        card.setAttribute('aria-pressed', 'false');
        card.dataset.variantId = firstAvailableVariant.id;
        card.addEventListener('click', this.handleProductSelect.bind(this, card));
        card.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.handleProductSelect(card);
          }
        }.bind(this));
      } else {
        card.classList.add('disabled');
      }
      
      card.dataset.productTitle = product.title;
      card.dataset.productPrice = price;
      card.dataset.compareAtPrice = compareAtPriceFormatted;
      card.dataset.providesTags = providesTags;
      
      return card;
    }.bind(this);

    this.loadProductsForSteps = async function() {
      for (let i = 0; i < this.steps.length; i++) {
        const step = this.steps[i];
        const grid = step.querySelector('.product-options-grid');
        const handles = grid.dataset.productHandles.split(',').filter(function(h) { return h.trim() !== ''; });
        
        if (handles.length > 0) {
          const productPromises = handles.map(this.fetchProductData);
          const products = await Promise.all(productPromises);
          
          grid.innerHTML = ''; // Clear spinner
          products.forEach(function(product) {
            if (product) {
              const card = this.createProductCard(product);
              grid.appendChild(card);
            }
          }.bind(this));
        } else {
          grid.innerHTML = '<p>No products have been assigned to this step.</p>';
        }
      }
    }.bind(this);

    this.calculateAvailableSteps = function() {
      this.availableSteps = [];
      const allSelectedTags = Object.values(this.selections).flat().map(function(item) { return item.providesTags.split(','); }).flat();
      
      this.steps.forEach(function(step, index) {
          const dependencyTags = step.dataset.dependencyTags.split(',').map(function(t) { return t.trim(); }).filter(function(t) { return t; });
          const dependencyLogic = step.dataset.dependencyLogic;

          if (dependencyTags.length === 0) {
            this.availableSteps.push(index);
            return;
          }

          if (dependencyLogic === 'any') { // OR logic
            if (dependencyTags.some(function(tag) { return allSelectedTags.includes(tag); })) {
              this.availableSteps.push(index);
            }
          } else { // AND logic
            if (dependencyTags.every(function(tag) { return allSelectedTags.includes(tag); })) {
              this.availableSteps.push(index);
            }
          }
      }.bind(this));
    }.bind(this);

    this.renderProgressIndicator = function() {
      this.progressIndicator.innerHTML = '';
      this.availableSteps.forEach(function(stepIndex) {
          const dot = document.createElement('div');
          dot.classList.add('progress-dot');
          const availableStepIndex = this.availableSteps.indexOf(stepIndex);
          if (availableStepIndex === this.currentStepIndex) dot.classList.add('active');
          if (this.selections[stepIndex] && this.selections[stepIndex].length > 0) dot.classList.add('completed');
          this.progressIndicator.appendChild(dot);
      }.bind(this));
    }.bind(this);

    this.showStep = function(index) {
      this.steps.forEach(function(step) { step.style.display = 'none'; });
      this.summaryStep.style.display = 'none';
      if (index >= this.availableSteps.length) {
        this.summaryStep.style.display = 'block';
        this.updateSummary();
      } else {
        const actualIndex = this.availableSteps[index];
        this.steps[actualIndex].style.display = 'block';
      }
      this.updateNavButtons();
      this.renderProgressIndicator();
    }.bind(this);
    
    this.updateNavButtons = function() {
      this.prevButton.style.visibility = this.currentStepIndex > 0 ? 'visible' : 'hidden';
      if (this.currentStepIndex >= this.availableSteps.length) {
          this.nextButton.style.display = 'none';
          this.addToCartButton.style.display = 'inline-flex';
      } else {
          this.nextButton.style.display = 'block';
          this.addToCartButton.style.display = 'none';
          const currentActualStepIndex = this.availableSteps[this.currentStepIndex];
          const currentStepElement = this.steps[currentActualStepIndex];
          const isRequired = currentStepElement.dataset.isRequired === 'true';
          this.nextButton.disabled = isRequired && (!this.selections[currentActualStepIndex] || this.selections[currentActualStepIndex].length === 0);
      }
    }.bind(this);

    this.handleProductSelect = function(card) {
      const stepElement = card.closest('.customizer-step');
      const stepIndex = parseInt(stepElement.dataset.stepIndex, 10);
      const allowMultiple = stepElement.dataset.allowMultiple === 'true';
      const { variantId, productTitle, productPrice, compareAtPrice, providesTags } = card.dataset;
      const selectionData = { variantId: variantId, title: productTitle, price: productPrice, compareAtPrice: compareAtPrice, providesTags: providesTags };

      if (!this.selections[stepIndex]) {
        this.selections[stepIndex] = [];
      }

      const isSelected = card.classList.contains('selected');
      const itemIndex = this.selections[stepIndex].findIndex(function(item) { return item.variantId === variantId; });

      if (allowMultiple) {
        if (isSelected) {
          card.classList.remove('selected');
          if (itemIndex > -1) {
            this.selections[stepIndex].splice(itemIndex, 1);
          }
        } else {
          card.classList.add('selected');
          if (itemIndex === -1) {
            this.selections[stepIndex].push(selectionData);
          }
        }
      } else {
        const currentlySelected = stepElement.querySelector('.product-option-card.selected');
        if (currentlySelected) {
          currentlySelected.classList.remove('selected');
        }
        
        if (currentlySelected !== card) {
          card.classList.add('selected');
          this.selections[stepIndex] = [selectionData];
        } else {
          this.selections[stepIndex] = [];
        }
      }
      
      const previousAvailableStepsCount = this.availableSteps.length;
      this.calculateAvailableSteps();
      if (this.availableSteps.length !== previousAvailableStepsCount) {
          Object.keys(this.selections).forEach(function(selIndex) {
              if (!this.availableSteps.includes(parseInt(selIndex))) {
                  delete this.selections[selIndex];
              }
          }.bind(this));
      }
      this.updateNavButtons();
      this.renderProgressIndicator();
      this.updateMainATCState(); // Check if main ATC can be unlocked
    }.bind(this);

    this.updateSummary = function() {
      this.summaryList.innerHTML = '';
      
      const mainProductForm = document.querySelector('form.shopify-product-form');
      const mainProductTitleEl = document.querySelector('.product-details h1');
      const mainProductPriceEl = document.querySelector('product-price .price');
      
      if (mainProductForm && mainProductTitleEl && mainProductPriceEl) {
        const mainItem = document.createElement('div');
        mainItem.className = 'summary-item summary-item--main-product';
        
        const titleSpan = document.createElement('span');
        titleSpan.className = 'summary-item-title';
        titleSpan.textContent = mainProductTitleEl.textContent.trim() + ' (Main Fireplace)';

        const priceSpan = document.createElement('span');
        priceSpan.className = 'summary-item-price';
        priceSpan.textContent = mainProductPriceEl.textContent.trim();

        mainItem.appendChild(titleSpan);
        mainItem.appendChild(priceSpan);
        this.summaryList.appendChild(mainItem);
      }

      const totalSelections = Object.values(this.selections).flat();
      totalSelections.forEach(function(sel) {
          const item = document.createElement('div');
          item.classList.add('summary-item');
          
          const titleSpan = document.createElement('span');
          titleSpan.classList.add('summary-item-title');
          titleSpan.textContent = sel.title;

          const priceSpan = document.createElement('span');
          priceSpan.className = 'summary-item-price';
          let priceHTML = '<span>' + sel.price + '</span>';
          if (sel.compareAtPrice) {
            priceHTML = '<del>' + sel.compareAtPrice + '</del> ' + priceHTML;
          }
          priceSpan.innerHTML = priceHTML;

          item.appendChild(titleSpan);
          item.appendChild(priceSpan);
          this.summaryList.appendChild(item);
      }.bind(this));
      
      const allRequiredMet = this.checkIfAllRequiredMet();
      this.addToCartButton.disabled = this.hasRequiredSteps && !allRequiredMet;

    }.bind(this);

    this.handleAddToCart = async function() {
      const buttonText = this.addToCartButton.querySelector('.button-text');
      const spinner = this.addToCartButton.querySelector('.button-spinner');
      this.addToCartButton.disabled = true;
      buttonText.style.display = 'none';
      spinner.style.display = 'block';

      const items = Object.values(this.selections).flat().map(function(sel) { return { id: sel.variantId, quantity: 1 }; });

      const mainProductForm = document.querySelector('form.shopify-product-form');
      if (mainProductForm) {
        const mainVariantIdInput = mainProductForm.querySelector('[name="id"]');
        if (mainVariantIdInput && mainVariantIdInput.value) {
          items.push({ id: mainVariantIdInput.value, quantity: 1 });
        }
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });

        const responseData = await response.json();

        if (response.status !== 200) {
          throw new Error(responseData.description || responseData.message || 'Failed to add items.');
        }

        this.addToCartButton.style.display = 'none';
        const successMessageEl = document.createElement('p');
        successMessageEl.className = 'add-to-cart-success';
        successMessageEl.textContent = this.container.dataset.successMessage;
        this.addToCartButton.parentNode.insertBefore(successMessageEl, this.addToCartButton.nextSibling);
        
        this.triggerCartUpdate();

      } catch (error) {
        console.error('[Customizer] Error adding to cart:', error);
        spinner.style.display = 'none';
        buttonText.textContent = error.message.slice(0, 30) || 'Error! Try Again';
        buttonText.style.display = 'inline-block';
        this.addToCartButton.disabled = false;
      }
    }.bind(this);

    this.triggerCartUpdate = async function() {
      try {
        const headerElement = document.getElementById('shopify-section-sections--20304419029247__header_section') || document.querySelector('.shopify-section.header');
        if (!headerElement) {
          this.openCartDrawer();
          return;
        }
        
        const sectionId = headerElement.id.replace('shopify-section-', '');
        if (!sectionId) {
          this.openCartDrawer();
          return;
        }

        const response = await fetch('/?section_id=' + sectionId);
        const htmlText = await response.text();
        const newHeaderDoc = new DOMParser().parseFromString(htmlText, 'text/html');
        const newHeaderContent = newHeaderDoc.querySelector('#shopify-section-' + sectionId);

        if (newHeaderContent) {
          headerElement.innerHTML = newHeaderContent.innerHTML;
          headerElement.querySelectorAll('script').forEach(function(oldScript) {
              const newScript = document.createElement('script');
              Array.from(oldScript.attributes).forEach(function(attr) { newScript.setAttribute(attr.name, attr.value); });
              newScript.appendChild(document.createTextNode(oldScript.innerHTML));
              oldScript.parentNode.replaceChild(newScript, oldScript);
          });
        }

        setTimeout(this.openCartDrawer.bind(this), 250);

      } catch (e) {
        console.error('[Customizer] Error forcing header refresh:', e);
        setTimeout(this.openCartDrawer.bind(this), 500);
      }
    }.bind(this);
    
    this.openCartDrawer = function() {
      // Intentionally left blank to prevent drawer from opening as per user request.
    }.bind(this);

    this.checkIfAllRequiredMet = function() {
      const requiredActiveSteps = this.availableSteps
        .map(i => this.steps[i])
        .filter(function(step) { return step.dataset.isRequired === 'true'; });
      
      return requiredActiveSteps.every(function(step) {
        const stepIndex = step.dataset.stepIndex;
        return this.selections[stepIndex] && this.selections[stepIndex].length > 0;
      }.bind(this));
    }.bind(this);

    this.initMainATCListener = function() {
      this.hasRequiredSteps = this.steps.some(function(step) { return step.dataset.isRequired === 'true'; });

      if (!this.hasRequiredSteps) return;

      const productForm = document.querySelector('form.shopify-product-form');
      this.mainATCButton = productForm ? productForm.querySelector('[name="add"]') : null;

      if (!this.mainATCButton) {
        console.warn('[Customizer] Could not find the main product form\'s "Add to Cart" button to control.');
        return;
      }
      
      const buttonContainer = this.mainATCButton.closest('.product-form-buttons');
      const existingWarning = buttonContainer ? buttonContainer.querySelector('.main-atc-warning') : null;
      if (existingWarning) existingWarning.remove();

      this.warningMessage = document.createElement('div');
      this.warningMessage.className = 'main-atc-warning';
      this.warningMessage.textContent = this.mainAtcWarningText;
      
      if (buttonContainer) {
        buttonContainer.appendChild(this.warningMessage);
      } else {
        this.mainATCButton.parentNode.insertBefore(this.warningMessage, this.mainATCButton.nextSibling);
      }

      // Permanently disable the button if there are required steps
      this.mainATCButton.disabled = true;
      this.mainATCButton.style.display = 'none'; // Hide the button completely
      this.warningMessage.style.display = 'block';

    }.bind(this);

    this.updateMainATCState = function() {
      // The button is now permanently locked in initMainATCListener if required steps exist.
    }.bind(this);
    
    this.attachEventListeners = function() {
      this.nextButton.addEventListener('click', function() {
          if (this.currentStepIndex < this.availableSteps.length) {
              this.currentStepIndex++;
              this.showStep(this.currentStepIndex);
          }
      }.bind(this));
      this.prevButton.addEventListener('click', function() {
          if (this.currentStepIndex > 0) {
              this.currentStepIndex--;
              this.showStep(this.currentStepIndex);
          }
      }.bind(this));
      this.addToCartButton.addEventListener('click', this.handleAddToCart.bind(this));
    }.bind(this);

    this.init();
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.fireplace-customizer-container').forEach(function(container) {
      if (!container.dataset.customizerInitialized) {
        container.dataset.customizerInitialized = true;
        new FireplaceCustomizer(container);
      }
    });
  });

  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('fireplace-customizer-container')) {
      const container = event.target;
      if (!container.dataset.customizerInitialized) {
        container.dataset.customizerInitialized = true;
        new FireplaceCustomizer(container);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
